import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { GET, POST, PUT, DELETE, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

// Hikvision Face ID terminallari — davomat qurilmalari.
// Baza tayyor edi (hikvision_devices, employees.hikvision_person_id, attendances.method),
// bu sahifa qurilmalarni ro'yxatga olish va aloqani tekshirish uchun.
function Index() {
	const { t } = useTranslation()

	const emptyItem = {
		id: null, name: '', location: '', model: '',
		ip_address: '', port: 80, isapi_username: 'admin', isapi_password: '', serial: '', status: 1,
	}

	const [data, setData] = useState([])
	const [modal, setModal] = useState({ show: false, item: emptyItem })
	const [testResult, setTestResult] = useState({})
	const [unmatched, setUnmatched] = useState([])
	const [employees, setEmployees] = useState([])
	const [linkSel, setLinkSel] = useState({})
	const [copied, setCopied] = useState(null)

	async function getData() {
		const response = await GET('/hikvision-devices', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	// Qurilma shu havolaga hodisa yuboradi (HTTP Listening)
	function webhookUrl(token) {
		const base = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://127.0.0.1:8000/api' : 'https://backend.tameer.uz/api')
		return base + '/hik/event/' + token
	}

	function copyUrl(token, id) {
		navigator.clipboard.writeText(webhookUrl(token))
		setCopied(id)
		setTimeout(() => setCopied(null), 1500)
	}

	async function getUnmatched() {
		const response = await GET('/hikvision-unmatched', {}, { loader: false })
		if (httpOk(response)) setUnmatched(response.data)
	}

	async function getEmployees() {
		// employees jadvalidan (login'siz xodimlar ham) — link employees.id ni kutadi.
		// /helper/employees users (login akkauntlar) ni beradi, shuning uchun ISHLATILMAYDI.
		const response = await GET('/helper/employees-list', {}, { loader: false })
		if (httpOk(response)) setEmployees(response.data)
	}

	async function linkPerson(employeeNo) {
		const employeeId = linkSel[employeeNo]
		if (!employeeId) return
		const response = await PUT('/hikvision-link', { employee_no: employeeNo, employee_id: employeeId }, { loader: true })
		if (httpOk(response)) { getUnmatched(); }
	}

	async function save(e) {
		e.preventDefault()
		const response = await POST('/hikvision-devices', modal.item, { loader: true })
		if (httpOk(response)) {
			setModal({ show: false, item: emptyItem })
			getData()
		}
	}

	async function remove(id) {
		const response = await DELETE(`/hikvision-devices/${id}`, {}, { loader: true })
		if (httpOk(response)) getData()
	}

	async function testConnection(id) {
		setTestResult({ ...testResult, [id]: { loading: true } })
		const response = await POST('/hikvision-devices/test', { id }, { loader: false })
		if (httpOk(response)) {
			setTestResult({ ...testResult, [id]: { ok: true } })
			getData()
		} else {
			setTestResult({ ...testResult, [id]: { ok: false, message: response?.data?.message || '' } })
		}
	}

	useEffect(() => {
		getData()
		getUnmatched()
		getEmployees()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('hikvision_devices')}</h4>
				<button className="btn btn-primary btn-rounded"
					onClick={() => setModal({ show: true, item: emptyItem })}>
					{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<p className="text-muted" style={{ fontSize: '13px' }}>{t('hikvision_hint')}</p>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }}>#</th>
									<th style={{ width: '22%' }}>{t('name')}</th>
									<th style={{ width: '18%' }}>{t('address')}</th>
									<th style={{ width: '16%' }}>IP : {t('port')}</th>
									<th style={{ width: '12%' }}>{t('login')}</th>
									<th style={{ width: '14%' }} className="text-center">{t('status')}</th>
									<th style={{ width: '18%' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td className="fw-600">
											{item.name}
											{item.token &&
												<div className="d-flex align-items-center gap-1 mt-1">
													<code style={{ fontSize: '10.5px', wordBreak: 'break-all' }}>{webhookUrl(item.token)}</code>
													<button className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: '10px' }}
														onClick={() => copyUrl(item.token, item.id)}>
														{copied === item.id ? '✓' : t('copy')}
													</button>
												</div>
											}
										</td>
										<td>{item.location || '—'}</td>
										<td className="text-nowrap">{item.ip_address || '—'} : {item.port}</td>
										<td>{item.isapi_username || '—'}</td>
										<td className="text-center">
											{Number(item.status) === 1
												? <span className="badge bg-success">{t('activated')}</span>
												: <span className="badge bg-secondary">—</span>}
											{item.last_event_at &&
												<div className="text-muted" style={{ fontSize: '11px' }}>
													{formatDate(item.last_event_at, 'dd.MM.yyyy HH:mm')}
												</div>
											}
										</td>
										<td className="text-end text-nowrap">
											<button className="btn btn-sm btn-outline-primary me-1"
												onClick={() => testConnection(item.id)}>
												{testResult[item.id]?.loading ? '...' : t('check')}
											</button>
											<button className="btn btn-sm btn-outline-secondary me-1"
												onClick={() => setModal({ show: true, item: { ...item, isapi_password: '' } })}>
												{t('edit')}
											</button>
											<button className="btn btn-sm btn-outline-danger"
												onClick={() => remove(item.id)}>
												{t('delete')}
											</button>
											{testResult[item.id] && !testResult[item.id].loading &&
												<div style={{ fontSize: '11.5px' }}
													className={testResult[item.id].ok ? 'text-success' : 'text-danger'}>
													{testResult[item.id].ok ? t('device_test_success') : testResult[item.id].message}
												</div>
											}
										</td>
									</tr>
								))}
								{data.length === 0 &&
									<tr><td colSpan="7" className="text-center text-muted py-4">{t('list_empty')}</td></tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{unmatched.length > 0 &&
				<div className="card mt-3">
					<div className="card-body">
						<h6 className="fw-bold mb-1">{t('unmatched_persons')} <span className="badge bg-warning text-dark">{unmatched.length}</span></h6>
						<p className="text-muted" style={{ fontSize: '13px' }}>{t('unmatched_hint')}</p>
						<div className="table-responsive">
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th style={{ width: '25%' }}>{t('name')}</th>
										<th style={{ width: '18%' }}>ID</th>
										<th style={{ width: '12%' }} className="text-center">{t('quantity')}</th>
										<th style={{ width: '15%' }} className="text-center">{t('date')}</th>
										<th style={{ width: '30%' }}>{t('employee')}</th>
									</tr>
								</thead>
								<tbody>
									{unmatched.map((p, i) => (
										<tr key={i}>
											<td className="fw-600">{p.person_name || '—'}</td>
											<td><code style={{ fontSize: '11.5px' }}>{p.employee_no}</code></td>
											<td className="text-center">{p.events}</td>
											<td className="text-center text-nowrap">{formatDate(p.last_seen, 'dd.MM HH:mm')}</td>
											<td>
												<div className="d-flex gap-1">
													<select className="form-select form-select-sm"
														value={linkSel[p.employee_no] || ''}
														onChange={(e) => setLinkSel({ ...linkSel, [p.employee_no]: e.target.value })}>
														<option value="">—</option>
														{employees.map((emp) => (
															<option key={emp.id} value={emp.id}>{emp.name}</option>
														))}
													</select>
													<button className="btn btn-sm btn-primary text-nowrap"
														disabled={!linkSel[p.employee_no]}
														onClick={() => linkPerson(p.employee_no)}>
														{t('link')}
													</button>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			}

			<Modal show={modal.show} animation={false} centered
				onHide={() => setModal({ show: false, item: emptyItem })}>
				<form onSubmit={save}>
					<Modal.Header closeButton>
						<Modal.Title>{t('hikvision_devices')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="form-group">
							<label>{t('name')}<span className="text-danger">*</span></label>
							<input type="text" className="form-control" value={modal.item.name}
								onChange={(e) => setModal({ ...modal, item: { ...modal.item, name: e.target.value } })} required />
						</div>
						<div className="form-group">
							<label>{t('address')}</label>
							<input type="text" className="form-control" value={modal.item.location || ''}
								onChange={(e) => setModal({ ...modal, item: { ...modal.item, location: e.target.value } })} />
						</div>
						<div className="row">
							<div className="form-group col-8">
								<label>IP<span className="text-danger">*</span></label>
								<input type="text" className="form-control" placeholder="192.168.1.64" value={modal.item.ip_address || ''}
									onChange={(e) => setModal({ ...modal, item: { ...modal.item, ip_address: e.target.value } })} required />
							</div>
							<div className="form-group col-4">
								<label>{t('port')}</label>
								<input type="number" className="form-control" value={modal.item.port || 80}
									onChange={(e) => setModal({ ...modal, item: { ...modal.item, port: e.target.value } })} />
							</div>
						</div>
						<div className="row">
							<div className="form-group col-6">
								<label>{t('login')}</label>
								<input type="text" className="form-control" value={modal.item.isapi_username || ''}
									onChange={(e) => setModal({ ...modal, item: { ...modal.item, isapi_username: e.target.value } })} />
							</div>
							<div className="form-group col-6">
								<label>{t('password')}</label>
								<input type="password" className="form-control" placeholder={modal.item.id ? '••••••' : ''}
									value={modal.item.isapi_password || ''}
									onChange={(e) => setModal({ ...modal, item: { ...modal.item, isapi_password: e.target.value } })} />
							</div>
						</div>
						<div className="row">
							<div className="form-group col-6">
								<label>{t('model')}</label>
								<input type="text" className="form-control" value={modal.item.model || ''}
									onChange={(e) => setModal({ ...modal, item: { ...modal.item, model: e.target.value } })} />
							</div>
							<div className="form-group col-6">
								<label>{t('serial')}</label>
								<input type="text" className="form-control" value={modal.item.serial || ''}
									onChange={(e) => setModal({ ...modal, item: { ...modal.item, serial: e.target.value } })} />
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button type="button" className="btn btn-warning"
							onClick={() => setModal({ show: false, item: emptyItem })}>{t('cancel')}</button>
						<button type="submit" className="btn btn-primary">{t('save')}</button>
					</Modal.Footer>
				</form>
			</Modal>
		</>
	)
}

export default Index
